var _excluded = ["header", "content", "footer", "isLoading", "logo"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useRef } from 'react';
import { Box } from '../../components/internal';
import { Group } from '../../containers';
import { Fade, Loader, Logo } from '../../foundations';
import { useBreakpointValue } from '../../theme';
import { forwardRef, useHasOverflowY } from '../../utils';
import { useMultiStyleConfig } from '../../utils/use-style-config';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ExternalLayout = forwardRef((_ref, ref) => {
  var {
    header,
    content,
    footer,
    isLoading,
    logo
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var columns = useBreakpointValue({
    xs: 4,
    s: 8,
    m: 8,
    l: 8,
    xl: 16
  });
  var styles = useMultiStyleConfig('ExternalLayout', {
    columns
  });

  var defaultLogo = /*#__PURE__*/_jsx(Logo, {
    "data-testid": "logo",
    size: "large",
    type: "light"
  });

  var contentRef = useRef(null);
  var isContentOverflowing = useHasOverflowY({
    ref: contentRef
  });
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    __css: styles['container'],
    "data-component": "ExternalLayout"
  }, props), {}, {
    ref: ref,
    children: isLoading ? /*#__PURE__*/_jsx(Loader, {}) : /*#__PURE__*/_jsx(Fade, {
      in: true,
      style: {
        width: 'inherit',
        height: 'inherit'
      },
      children: /*#__PURE__*/_jsxs(Box, {
        __css: styles['wrapper'],
        tabIndex: isContentOverflowing ? 0 : -1,
        ref: contentRef,
        children: [/*#__PURE__*/_jsx(Box, {
          __css: styles['header']
        }), /*#__PURE__*/_jsxs(Box, {
          __css: styles['fixedHeader'],
          children: [/*#__PURE__*/_jsx(Box, {
            __css: styles['logoContainer'],
            children: logo !== null && logo !== void 0 ? logo : defaultLogo
          }), header && /*#__PURE__*/_jsx(Box, {
            __css: styles['headerContainer'],
            children: header
          })]
        }), /*#__PURE__*/_jsx(Box, {
          __css: styles['grid'],
          children: /*#__PURE__*/_jsx(Box, {
            __css: styles['gridItemContent'],
            children: /*#__PURE__*/_jsxs(Group, {
              variant: "vertical",
              spacing: "m",
              children: [content, footer]
            })
          })
        })]
      })
    })
  }));
});
ExternalLayout.displayName = 'ExternalLayout';
//# sourceMappingURL=ExternalLayout.js.map